import { __extends } from "tslib";
import * as React from 'react';
import { SatisfactionRatingType } from '@wix/answers-api';
import { compKey } from './key';
import { AnsViewComp } from '@wix/answers-lib';
import { CsatSurveyView } from './csat-survey-view';
export var MAX_COMMENT_LENGTH = 1200;
var DEFAULT_RATING_REQUEST_MESSAGE_KEY = 'rating-request-message';
var FEEDBACK_RECEIVED_MESSAGE_KEY = 'feedback-received-message';
export var satisfactionKeyToString = function (satisfactionKey) {
    switch (satisfactionKey) {
        case SatisfactionRatingType.POSITIVE:
            return 'positive';
        case SatisfactionRatingType.NEUTRAL:
            return 'neutral';
        case SatisfactionRatingType.NEGATIVE:
            return 'negative';
        default:
            return;
    }
};
var getCommentResponseKey = function (satisfactionType) {
    return "customer-comments." + satisfactionKeyToString(satisfactionType) + "-response";
};
var getCommentFollowupKey = function (satisfactionType) {
    return "customer-comments." + satisfactionKeyToString(satisfactionType) + "-followup";
};
var translationPrefix = compKey;
var CsatSurvey = /** @class */ (function (_super) {
    __extends(CsatSurvey, _super);
    function CsatSurvey() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedOption: _this.props.initialSelection || null,
            userComment: '',
        };
        _this.tp = function (key, params) {
            return _this.props.t(translationPrefix + "." + key, params);
        };
        _this.setSelectedOption = function (selectedOption) {
            return _this.setState({ selectedOption: selectedOption });
        };
        _this.getOptionClassName = function (option, selected) {
            return "satisfaction-option satisfaction-" + option + " " + (selected ? 'selected' : '');
        };
        _this.onSubmit = function () {
            if (_this.state.selectedOption) {
                return _this.props.onSubmit({
                    satisfactionLevel: _this.state.selectedOption,
                    userComment: _this.state.userComment,
                });
            }
            else {
                return Promise.reject();
            }
        };
        _this.setUserComment = function (userComment) {
            return _this.setState({ userComment: userComment });
        };
        _this.onSelectOption = function (optionToSelect) {
            return _this.setSelectedOption(optionToSelect);
        };
        _this.getResponseMessage = function () {
            var _a = _this, props = _a.props, state = _a.state, tp = _a.tp;
            var selectedOption = state.selectedOption;
            if (!selectedOption) {
                return '';
            }
            var customizedRatingResponses = props.csatContent.customizedRatingResponses;
            var option = customizedRatingResponses[selectedOption];
            var defaultResponseMessage = selectedOption && tp(getCommentResponseKey(selectedOption));
            return option.responseMessageEnabled ? option.responseMessage || defaultResponseMessage : undefined;
        };
        _this.getFollowUpMessage = function () {
            var _a = _this, props = _a.props, state = _a.state, tp = _a.tp;
            var selectedOption = state.selectedOption;
            if (!selectedOption) {
                return '';
            }
            var customizedRatingResponses = props.csatContent.customizedRatingResponses;
            var option = customizedRatingResponses[selectedOption];
            var defaultFollowUpMessage = selectedOption && tp(getCommentFollowupKey(selectedOption));
            return option.followUpMessageEnabled ? option.followUpMessage || defaultFollowUpMessage : undefined;
        };
        return _this;
    }
    CsatSurvey.prototype.componentDidMount = function () {
        var _a, _b;
        (_b = (_a = this.props).onSurveyLoaded) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    CsatSurvey.prototype.render = function () {
        var _a = this, props = _a.props, tp = _a.tp, state = _a.state;
        var selectedOption = state.selectedOption, userComment = state.userComment;
        var ratingRequestMessage = props.csatContent.ratingRequestMessage ||
            tp(DEFAULT_RATING_REQUEST_MESSAGE_KEY);
        var updateSubmissionMessage = props.automaticSubmissionMode ? tp('update-submission-message') : '';
        var thankYouMessage = props.csatContent.feedbackReceivedMessage ||
            tp(FEEDBACK_RECEIVED_MESSAGE_KEY);
        return (React.createElement(CsatSurveyView, { ratingRequestMessage: updateSubmissionMessage || ratingRequestMessage, hiddenRatingTypes: props.hiddenRatingTypes, customerCommentEnabled: props.csatContent.customerCommentEnabled, followUpMessage: this.getFollowUpMessage(), responseMessage: this.getResponseMessage(), userComment: userComment, maxUserCommentLength: MAX_COMMENT_LENGTH, selectedOption: selectedOption, onSubmit: this.onSubmit, onSelectOption: this.onSelectOption, setUserComment: this.setUserComment, thankYouMessage: thankYouMessage, automaticSubmissionMode: props.automaticSubmissionMode, t: this.tp }));
    };
    return CsatSurvey;
}(AnsViewComp));
export { CsatSurvey };
//# sourceMappingURL=index.js.map